import { useState, useEffect } from 'react';

const translations = {
  de: require('./de.json'),
  it: require('./it.json'),
  se: require('./se.json'),
};

export const useTranslation = (locale) => {
  const [t, setT] = useState({});

  useEffect(() => {
    if (translations[locale]) {
      setT(translations[locale]);
    }
  }, [locale]);

  const translate = (key) => {
    const keys = key.split('.');
    let value = t;
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value;
  };

  return { t: translate, translations: t };
};
